<template>
  <div>

    <Head title="Domains" />
    <h1 class="mb-8 text-3xl font-bold">Domains</h1>
    <div class="flex items-center mb-6">

      <search-filter :hideSearch="true" :title="'Sortierung'" v-model="form.search" class="" @reset="reset">
        <label class="block text-gray-700">Sortieren nach:</label>
        <select v-model="form.sortByCol" class="form-select mt-1 w-full">
          <option v-for="column in columns" :value="column"> {{ column }}</option>
        </select>
        <label class="block text-gray-700 mt-8">Anzahl der Ergebnisse:</label>
        <select v-model="form.itemsPerPage" class="form-select mt-1 mb-4 w-full">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="75">75</option>
          <option value="100">100</option>
        </select>
      </search-filter>

      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Aktiv:</label>
        <select v-model="form.active" class="form-select mt-1 mb-4 w-full">
          <option value="">Alle anzeigen</option>
          <option value="onlyAct">Nur aktive anzeigen</option>
          <option value="onlyInact">Nur inaktive anzeigen</option>
          <option value="onlyCanceled">Nur gekündigte anzeigen</option>
        </select>
        <label class="block text-gray-700">Server:</label>
        <select v-model="form.server" class="form-select mt-1 mb-4 w-full">
          <option value="">Server auswählen</option>
          <option v-for="server in servers" :value="server.ip"> {{ server.name }}</option>
        </select>
        <label class="block text-gray-700">Abrechnung:</label>
        <select v-model="form.upcomingPayment" class="form-select mt-1 mb-4 w-full">
          <option value="">Alle anzeigen</option>
          <option value="upcoming">Anstehnde anzeigen</option>
        </select>
      </search-filter>
      <div class="ml-auto flex items-center">
        <icon @click="setEditMode" name="edit" :color="editMode ? '#0082aa' : '#555'"
          class=" cursor-pointer block w-8 h-8 mr-6 transition-all hover:scale-105" />
        <a :href="queryLink" class="btn-primary-100 mr-6 " v-if="selectedRows['domains'].length > 0 && editMode">{{
          selectedRows['domains'].length }}
          Domains
          bearbeiten</a>
        <Link class="btn-primary-100" href="/domains/create">
        <span>Domain</span>
        <span class="hidden md:inline">&nbsp;Erstellen</span>
        </Link>
      </div>

    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap transition-all" :class="editMode ? 'border-t-4 border-primary-100' : ''">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6" v-if="editMode">
            <icon @click="selectAllDomains(domains.data)" name="edit" color="#0082aa"
              class="mx-auto cursor-pointer	block w-6 h-6 transition-all hover:scale-105" />
          </th>
          <th class="pb-4 pt-6 px-6" v-for="column in columns">
            <a href="#" @click="sortBy(column)"
              :class="{ active: sortKey == column, desc: form.sortDirection == 'DESC' }">
              {{ column }}
            </a>
          </th>
        </tr>
        <tr v-for="domain in domains.data" :key="domain.id" class="hover:bg-gray-100 focus-within:bg-gray-100"
          :class="{ 'bg-gray-50': domain.active == 0 }">
          <td class="border-t" v-if="editMode">
            <div class="flex items-center">
              <input v-model="selectedRows['checkboxes']" :value="domain.id" type="checkbox" :id="'check-' + domain.id"
                @change="toggleSelection(domain, $event)" class=" hidden peer" />
              <label :for="'check-' + domain.id"
                class="select-none cursor-pointer flex items-center justify-center rounded-full w-5 h-5 bg-gray-100 border-2 border-slate-500 peer-checked:bg-primary-100 peer-checked:border-primary-100 transition-all block mx-auto">
                <span hidden>Check</span>
              </label>
            </div>
          </td>
          <td class="border-t">
            <Link class=" flex items-center px-6 py-4 text-primary-200 focus:text-primary-200"
              :href="`/domains/${domain.id}/edit`">
            <icon v-if="!domain.active" name="inactive" class="flex-shrink-0 ml-2 w-3 h-3 fill-red-500" />
            <icon v-if="domain.active && !domain.flaged" name="active"
              class="flex-shrink-0 ml-2 w-3 h-3 fill-green-500" />
            <icon v-if="domain.flaged && domain.active" name="active"
              class="flex-shrink-0 ml-2 w-3 h-3 fill-yellow-500" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 text-primary-100 focus:text-primary-200"
              :href="`/domains/${domain.id}/edit`">
            {{ domain.domain }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/domains/${domain.id}/edit`">
            <span v-if="domain.server_name">
              {{ domain.server_name.name }}
            </span>
            <span v-else>_Fremdserver</span>
            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/domains/${domain.id}/edit`" tabindex="-1">
            <span v-if="domain.active && domain.ordered_at != null"> {{
              domain.ordered_at }}</span>
            <span v-else> - </span>
            </Link>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4" tabindex="-1">
              <span
                :class="{ 'text-red-500': domain.status == 'isInPast', 'text-orange-500': domain.status == 'isThisWeek', 'text-yellow-500': domain.status == 'isThisMonth' }"
                v-if="domain.active && domain.charged_till != null && domain.charged"> {{ domain.charged_till }}</span>
              <span v-else> - </span>


            </div>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/domains/${domain.id}/edit`" tabindex="-1">
            {{ domain.amount_net }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/domains/${domain.id}/edit`" tabindex="-1">
            {{ domain.comment }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/domains/${domain.id}/edit`" tabindex="-1">
            {{ domain.package }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 hover:text-primary-100"
              :href="`/customers/${domain.customer.id}/edit`" tabindex="-1">
            <div v-if="domain.customer">
              {{ domain.customer.name }}
            </div>
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/domains/${domain.id}/edit`" tabindex="-1">
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="domains.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No domains found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="domains.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { ref } from 'vue';

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    itemsPerPage: Number,
    filters: Object,
    servers: Object,
    domains: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        sortByCol: this.filters.sortByCol ? this.filters.sortByCol : 'Domain',
        active: this.filters.active ? this.filters.active : '',
        upcomingPayment: this.filters.upcomingPayment ? this.filters.upcomingPayment : '',
        server: this.filters.server ? this.filters.server : '',
        sortDirection: this.filters.sortDirection,
        itemsPerPage: this.filters.itemsPerPage ? this.filters.itemsPerPage : 50
      },
      columns: [
        'Aktiv',
        'Domain',
        'Server',
        'Bestellt am',
        'Rechnung am',
        'Betrag/NETTO',
        'Bemerkung',
        'Paket',
        'Besitzer',
      ],
      sortKey: 'Domain',
      editMode: false,
      selectedRows: {
        "checkboxes": [],
        "domains": [],
      }
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/domains', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    queryLink() {   
      // Convert the array of IDs to a query string
      const queryString = this.selectedRows.checkboxes.map(id => `id[]=${id}`).join('&');
      // Create the full URL
      return `domains/massedit?${queryString}`;
    }    
  },
  methods: {
    setEditMode() {
      this.editMode = !this.editMode;
      this.selectedRows['checkboxes'] = [];
      this.selectedRows['domains'] = [];
    },
    selectAllDomains(domains) {
      if (this.selectedRows['checkboxes'].length > 0) {
        this.selectedRows['checkboxes'] = [];
        this.selectedRows['domains'] = [];
      } else {
        this.selectedRows['checkboxes'] = domains.map(domain => domain.id);
        domains.forEach(row => {
          this.selectedRows['domains'].push(row);
        });
      }
    },
    toggleSelection(row, event) {
      if (event.target.checked) {
        this.selectedRows['domains'].push(row);
      } else {
        const index = this.selectedRows['domains'].indexOf(row);
        if (index > -1) {
          this.selectedRows['domains'].splice(index, 1);
        }
      }
      console.log(this.selectedRows);

    },
    sortBy(column) {
      if (this.form.sortDirection == 'DESC') {
        this.form.sortDirection = 'ASC'
      } else {
        if (this.form.sortByCol == column) {
          this.form.sortDirection = 'DESC'
        }
      }
      this.form.sortByCol = column;
      this.sortKey = column;
      console.log(this.domains);
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
